import * as Yup from 'yup';

import { DATE_MATCH_REGEXP } from 'utils/curo-helpers/validation';

import {
  EmploymentType,
  IIncomeSourcesFormValues,
  IncomeSourcesFields,
  PaycheckFrequency,
} from './constants';

export const incomeInformationFormValidationSchema = Yup.object<
  Yup.ObjectSchema<IIncomeSourcesFormValues>
>().shape({
  [IncomeSourcesFields.EmploymentType]: Yup.string()
    .oneOf([EmploymentType.Employed, EmploymentType.SelfEmployed, EmploymentType.Other])
    .required('Employment Type is required'),
  [IncomeSourcesFields.GrossMonthlyIncome]: Yup.number().required('Income is required'),
  [IncomeSourcesFields.NextPayDate]: Yup.string()
    .required('Pay Date is required')
    .matches(DATE_MATCH_REGEXP, 'Invalid date'),
  [IncomeSourcesFields.PaycheckFrequency]: Yup.string()
    .oneOf([
      PaycheckFrequency.BiWeekly,
      PaycheckFrequency.Monthly,
      PaycheckFrequency.SemiMonthly,
      PaycheckFrequency.Weekly,
    ])
    .required('Pay frequency is required'),
  [IncomeSourcesFields.SourceOfIncome]: Yup.string().when(
    IncomeSourcesFields.EmploymentType,
    ([employmentType]) => {
      if (employmentType === EmploymentType.Other) {
        return Yup.string().required('Source of Income is required');
      }

      return Yup.string().optional();
    },
  ),
});
